import React from 'react';
import { WebIcon } from 'constants/icons';
import Buttons from './buttons/buttons';
import styles from './header.module.scss';

interface iProps {
  className?: string;
  isEditWebContent: boolean;
}

function Header(props: iProps): JSX.Element {
  const { className, isEditWebContent } = props;
  return (
    <div className={`${styles.addWebContentHeader} ${className}`}>
      <div className={styles.leftOne}>
        <img className={styles.webIcon} src={WebIcon} alt="" />
        <p className={styles.heading}>
          {isEditWebContent ? 'Edit Webpage' : 'Add Webpage'}
        </p>
      </div>
      <div className={styles.rightOne}>
        <Buttons />
      </div>
    </div>
  );
}

Header.defaultProps = {
  className: '',
};

export default Header;
